import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import { createFamilyGroupAction, updateFamilyGroupAction, } from "../../actions";
import { getFamilyTypeList, getSexList, getScholarshipList } from "../../selectors";
import { useDispatch, useSelector } from "react-redux";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateLocale } from "@icarius-localization/strings";
import Loader from "@icarius-common/loader";
import { getYesNoArray } from "@icarius-utils/constants";

const gridStyle = { height: 75, padding: "0px 10px" };

const CreateEditDialog = (props) => {

  const { open, isLoading, data, code, handleClose } = props;

  const dispatch = useDispatch();
  const familyTypeList = useSelector(getFamilyTypeList);
  const sexList = useSelector(getSexList);
  const scholarshipList = useSelector(getScholarshipList);

  const create = (dataToSend) => {
    dispatch(createFamilyGroupAction({ 'Código de empleado': code, ...dataToSend }))
      .then((res) => {
        if (res?.status === 200) {
          handleClose();
        }
      });
  }

  const modify = (dataToSend) => {
    dispatch(updateFamilyGroupAction({ internalCode: data.internalCode, 'Código de empleado': code, ...dataToSend }))
      .then((res) => {
        if (res?.status === 200) {
          handleClose();
        }
      });
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const { isCreate, formData, setFormValue, submit } = useHandleForm(data, create, modify, openValidationError);

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"md"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {isCreate ? getLocalizedString("createFamilyMemberRecord") : getLocalizedString("editFamilyRecord")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Loader open={isLoading} />
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                required
                fullWidth
                margin={"none"}
                onChange={(e) => setFormValue(e.target.value, "Código de familiar")}
                value={formData['Código de familiar']}
                label={getLocalizedString("relativeCode")}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                required
                fullWidth
                margin={"none"}
                onChange={(e) => setFormValue(e.target.value, "Apellido paterno")}
                value={formData['Apellido paterno']}
                label={getLocalizedString("fatherLastName")}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                fullWidth
                margin={"none"}
                onChange={(e) => setFormValue(e.target.value, "Apellido materno")}
                value={formData['Apellido materno']}
                label={getLocalizedString("motherLastName")}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                required
                fullWidth
                margin={"none"}
                onChange={(e) => setFormValue(e.target.value, "Primer nombre")}
                value={formData['Primer nombre']}
                label={getLocalizedString("firstName")}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                fullWidth
                margin={"none"}
                onChange={(e) => setFormValue(e.target.value, "Segundo nombre")}
                value={formData['Segundo nombre']}
                label={getLocalizedString("secondName")}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <TextField
                disabled
                fullWidth
                margin={"none"}
                value={formData['Apellidos y nombres']}
                label={getLocalizedString("namesAndLastnames")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-Tipo de familiar`}>{getLocalizedString("familyType")}</InputLabel>
                <Select
                  labelId={`label-Tipo de familiar`}
                  id={`select-Tipo de familiar`}
                  value={formData['Tipo de familiar']}
                  onChange={(e) => setFormValue(e.target.value, "Tipo de familiar")}
                  margin={"none"}
                >
                  {
                    familyTypeList.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-Sexo`}>{getLocalizedString("sex")}</InputLabel>
                <Select
                  labelId={`label-Sexo`}
                  id={`select-Sexo`}
                  value={formData['Sexo']}
                  onChange={(e) => setFormValue(e.target.value, "Sexo")}
                  margin={"none"}
                >
                  {
                    sexList.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                <DatePicker
                  fullWidth
                  required
                  label={getLocalizedString("income")}
                  cancelLabel={getLocalizedString("cancel")}
                  okLabel={getLocalizedString("ok")}
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  margin="none"
                  value={formData['Fecha de ingreso']}
                  onChange={(e) => setFormValue(e, 'Fecha de ingreso')}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            {
              formData['Tipo de familiar'] === 'HIJ' &&
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                  <DatePicker
                    fullWidth
                    required
                    label={getLocalizedString("bornDateVisibleShort")}
                    cancelLabel={getLocalizedString("cancel")}
                    okLabel={getLocalizedString("ok")}
                    invalidDateMessage=""
                    format="dd/MM/yyyy"
                    margin="none"
                    value={formData['Fecha de nacimiento']}
                    onChange={(e) => setFormValue(e, 'Fecha de nacimiento')}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            }
            {
              formData['Tipo de familiar'] === 'CON' &&
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                  <DatePicker
                    fullWidth
                    label={getLocalizedString("weddingDate")}
                    clearable
                    clearLabel={getLocalizedString("clear")}
                    cancelLabel={getLocalizedString("cancel")}
                    okLabel={getLocalizedString("ok")}
                    invalidDateMessage=""
                    format="dd/MM/yyyy"
                    margin="none"
                    value={formData['Fecha de casamiento']}
                    onChange={(e) => setFormValue(e, 'Fecha de casamiento')}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            }
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-Asignación familiar`}>{getLocalizedString("familyAllowance")}</InputLabel>
                <Select
                  labelId={`label-Asignación familiar`}
                  id={`select-Asignación familiar`}
                  value={formData['Asignación familiar']}
                  onChange={(e) => setFormValue(e.target.value, "Asignación familiar")}
                  margin={"none"}
                >
                  {
                    getYesNoArray().map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            {
              formData['Asignación familiar'] === 'Y' &&
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                  <DatePicker
                    fullWidth
                    label={getLocalizedString("assignmentDueDate")}
                    clearable
                    clearLabel={getLocalizedString("clear")}
                    cancelLabel={getLocalizedString("cancel")}
                    okLabel={getLocalizedString("ok")}
                    invalidDateMessage=""
                    format="dd/MM/yyyy"
                    margin="none"
                    value={formData['Fecha de vencimiento de la asignación']}
                    onChange={(e) => setFormValue(e, 'Fecha de vencimiento de la asignación')}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            }
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel required id={`label-Retención judicial`}>{getLocalizedString("judicialRetention")}</InputLabel>
                <Select
                  labelId={`label-Retención judicial`}
                  id={`select-Retención judicial`}
                  value={formData['Retención judicial']}
                  onChange={(e) => setFormValue(e.target.value, "Retención judicial")}
                  margin={"none"}
                >
                  {
                    getYesNoArray().map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            {
              formData['Tipo de familiar'] === 'HIJ' &&
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel required id={`label-Incapacidad`}>{getLocalizedString("disability")}</InputLabel>
                  <Select
                    labelId={`label-Incapacidad`}
                    id={`select-Incapacidad`}
                    value={formData['Incapacidad']}
                    onChange={(e) => setFormValue(e.target.value, "Incapacidad")}
                    margin={"none"}
                  >
                    {
                      getYesNoArray().map(item => (
                        <MenuItem
                          className={"whiteText"}
                          key={item.key}
                          value={item.key}
                        >
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
            }
            {
              formData['Tipo de familiar'] === 'HIJ' &&
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id={`label-Escolaridad`}>{getLocalizedString("schoolingSingular")}</InputLabel>
                  <Select
                    labelId={`label-Escolaridad`}
                    id={`select-Escolaridad`}
                    value={formData['Escolaridad']}
                    onChange={(e) => setFormValue(e.target.value, "Escolaridad")}
                    margin={"none"}
                  >
                    <MenuItem className={"whiteText"} value={''}>{'Sin valor'}</MenuItem>
                    {
                      scholarshipList.map(item => (
                        <MenuItem
                          className={"whiteText"}
                          key={item.key}
                          value={item.key}
                        >
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
            }
            {
              formData['Escolaridad'] &&
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                  <DatePicker
                    fullWidth
                    required
                    label={getLocalizedString("schoolCertificateYear")}
                    clearable
                    clearLabel={getLocalizedString("clear")}
                    cancelLabel={getLocalizedString("cancel")}
                    okLabel={getLocalizedString("ok")}
                    invalidDateMessage=""
                    format="yyyy"
                    margin="none"
                    value={formData['Año del certificado escolar']}
                    onChange={(e) => setFormValue(e, 'Año del certificado escolar')}
                    views={["year"]}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default CreateEditDialog;
